// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "trix"
import "@rails/actiontext"
import "./channels"
import "./controllers"
import "./src"

import LocalTime from "local-time"
LocalTime.start()

// Import Clipboard and make it globally available for Preline helper
import ClipboardJS from "clipboard"
window.ClipboardJS = ClipboardJS

// Import Preline - initialization handled by Stimulus controller
import "preline/preline"
import "preline/dist/helper-clipboard"

// Import ninja-keys for command palette (explicit import to prevent tree-shaking)
import { NinjaKeys } from "ninja-keys"
window.NinjaKeys = NinjaKeys
